import script from "./FaqEditor.vue?vue&type=script&setup=true&lang=js"
export * from "./FaqEditor.vue?vue&type=script&setup=true&lang=js"

import "./FaqEditor.vue?vue&type=style&index=0&id=794ced92&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-794ced92"]])

export default __exports__